module.exports = __webpack_public_path__ + "media/custom/images/img25-5db47be6c632b0ec968b0cf3349352c4.jpg";